module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"addNew":"Add new value","classifierCode":"Code","classifierKey":"Key","classifierValue":"Value","isEnabled":"Enabled"},"et":{"addNew":"Add new value","classifierCode":"Code","classifierKey":"Key","classifierValue":"Value","isEnabled":"Enabled"},"ru":{"addNew":"Add new value","classifierCode":"Code","classifierKey":"Key","classifierValue":"Value","isEnabled":"Enabled"}}')
  delete Component.options._Ctor
}
